import { render, staticRenderFns } from "./CloudflareTurnstileWidget.vue?vue&type=template&id=ddb53b82"
import script from "./CloudflareTurnstileWidget.vue?vue&type=script&lang=js"
export * from "./CloudflareTurnstileWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports